import { getHours, getMinutes, setHours, setMinutes } from 'date-fns';
export const roundToNextTenMinutes = (date: Date) => {
  const minutes = getMinutes(date);
  const roundedMinutes = Math.ceil(minutes / 10) * 10;
  return setMinutes(setHours(date, getHours(date)), roundedMinutes);
};
